class ChangeSubmit {
    constructor() {
        this._init()
    }
    _init() {
        document.querySelectorAll('[data-change-submit-form]').forEach(el => {
            el.querySelectorAll('[data-change-submit]').forEach(elAction => {
                elAction.addEventListener('change', () => {
                    el.dispatchEvent(new Event('submit'))
                    el.submit()
                })
            })
        })
    }
}

export default ChangeSubmit